/* eslint-disable indent */
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import cn from 'classnames';
import { VerticalGridItem, GridBlock } from '../../Support/Html/Components';

// GridBlock is used here instead of Grid item as on staging Grid items diaply property gets sometimes overwritten with display:none. This happens not very often but often enough to warrant this fix. At this point it is not clear to me why this is happening and due to deployment scheduled today we need ot have it fixed with this is workarround. It does work but should be investigated further when time allows. Something to look at is global.styles.copy that seems to duplicate global.styles and due to developers changing I'm not sure why this file was introduced in first place
const PlantInfo = ({ classes, plant }) => {
  return plant.trucks && plant.trucks.length ? (
    <Grid container spacing={1}>
      <GridBlock xs={12}>
        <Grid container alignItems="baseline" className={classes.flexWrapNowrap} spacing={1}>
          <GridBlock style={{ display: 'block !important' }}>
            <Typography variant="h6">{plant.name}</Typography>
          </GridBlock>
          <GridBlock className={classes.loadingCell}>
            <Typography variant="overline" className={classes.dotLoading}>
              Loading
            </Typography>
          </GridBlock>
        </Grid>
      </GridBlock>
      <GridBlock xs={12} className={classes.truckList}>
        <Grid container alignItems="stretch" spacing={1}>
          <GridBlock className={cn(classes.opacity05, classes.truckNoCol)}>
            <Typography variant="body2">Truck No.</Typography>
          </GridBlock>
          <VerticalGridItem classes={classes} />
          <GridBlock className={cn(classes.opacity05, classes.thisLoadCol)}>
            <Typography variant="body2">This Load</Typography>
          </GridBlock>
        </Grid>
        {plant.trucks.map((truck) => {
          return (
            <Grid key={truck.truckNumber} container alignItems="stretch" spacing={1}>
              <GridBlock className={classes.truckNoCol}>
                <Typography variant="body1" className={classes.truckRow}>
                  <span id={`truckRow_${truck.truckNumber}`}>{truck.truckNumber}</span>
                </Typography>
              </GridBlock>
              <VerticalGridItem classes={classes} />
              <GridBlock className={classes.thisLoadCol}>
                <Typography variant="body1" className={classes.truckRow}>
                  {parseFloat(truck.loadQty).toFixed(1)}m<sup>3</sup>
                </Typography>
              </GridBlock>
            </Grid>
          );
        })}
      </GridBlock>
    </Grid>
  ) : (
    <Grid container spacing={1}>
      <GridBlock xs={12}>
        <Typography variant="h6">{plant.name}</Typography>
      </GridBlock>
      <GridBlock xs={12}>
        <Typography className={classes.plantAddress} variant="body1">
          There are 0 trucks loading at this time
        </Typography>
      </GridBlock>
    </Grid>
  );
};

export default PlantInfo;
